import { gql } from "@apollo/client";

export const MY_PRODUCTS_QUERY = gql`
  query MyProducts($portalUserId: Int!) {
    myProducts(portalUserId: $portalUserId) {
      id
      customer_id
      product_id
      selected_version
      sold_on
      maint_through
      name
      description
      model_num
      arch
    }
  }
`;